import React from 'react';
import EditableCell from '../TariffTable/components/EditableCell';
import { ITariff } from '../../../../../interfaces/tariff';
import { TariffEditFields } from '../../../../../store/ducks/tariff.duck';

const EditableCellTariffFee: React.FC<{
  tariff: ITariff;
  editable: boolean;
  loading: boolean;
  success: boolean;
  fieldValue: keyof ITariff;
  field: TariffEditFields;
  index: number;
  submit: ({
    tariff,
    field,
    value,
    index,
  }: {
    tariff: ITariff;
    field: 'key' | 'value';
    value: number | string;
    index: number;
  }) => void;
}> = ({ tariff, editable, loading, success, field, fieldValue, submit, index }) => {
  if (fieldValue !== 'distance_fee') return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: '50%' }}>
        <EditableCell
          cell={{
            value: Object.keys(tariff[fieldValue] || {})?.[index] || 0,
            field,
            text: Object.keys(tariff[fieldValue] || {})?.[index] || 0,
          }}
          loading={loading}
          success={success}
          submit={newValue =>
            submit({
              tariff,
              field: 'key',
              value: newValue || 0,
              index,
            })
          }
          editable={editable}
        />
      </div>
      <div style={{ width: '50%' }}>
        <EditableCell
          cell={{
            value: Object.values(tariff[fieldValue] || {})?.[index] || 0,
            field,
            text: Object.values(tariff[fieldValue] || {})?.[index] || 0,
          }}
          loading={loading}
          success={success}
          submit={newValue =>
            submit({
              tariff,
              field: 'value',
              value: newValue || 0,
              index,
            })
          }
          editable={editable}
        />
      </div>
    </div>
  );
};

export default EditableCellTariffFee;
